module.exports = __webpack_public_path__ + "static/media/icon-sampling.4ab29abc.svg";